import { ProDescriptions } from '@ant-design/pro-components';
import PropTypes from 'prop-types';

const SeedPlanPreview = ({ record }) => (
  <ProDescriptions
    column={1}
    dataSource={record || {}}
    columns={[
      { title: '规划主题', dataIndex: 'title' },
      { title: '规划核心', dataIndex: 'keyword' },
      { title: '规划描述', dataIndex: 'description' },
      { title: '规划日期', dataIndex: 'plannedAt', valueType: 'date' },
      { title: '最新作者', dataIndex: 'userName', valueType: 'text' },
    ]}
  />
);

SeedPlanPreview.propTypes = {
  record: PropTypes.shape({}),
};

SeedPlanPreview.defaultProps = {
  record: undefined,
};

export default SeedPlanPreview;
